<template>
  <div id="app">

    <!-- the router outlet, where all matched components would ber viewed -->
    <router-view></router-view>

  </div>
</template>



<script>
export default {
  name: 'app',
}
</script>




<!-- styling for the component -->
<style lang="scss" scoped>
 // @import 'assets/css/main.css';
</style>


// WEBPACK FOOTER //
// src/App.vue